export class HTTPError extends Error {
    public readonly response: Response;
    public readonly request: Request;

    constructor(response: Response, request: Request) {
        super(`Request failed with status ${response.status} ${response.statusText}`);
        this.name = 'HTTPError';
        this.response = response;
        this.request = request;
    }
}
